// extracted by mini-css-extract-plugin
export default {"switchButton":"SwitchButton_switchButton__7NqP0"};